<template>
  <v-content>
    <v-content v-if="!isDataLoading & !hasData">
      <v-flex xs12>
        <label class="subheading">
          The email link you have followed to reach here is no longer valid -
          please contact your dealer.
        </label>
      </v-flex>
    </v-content>

    <v-content v-model="application">
      <v-dialog v-model="isDataLoading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by - Your application is being processed
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="rejected">
        <v-card>
          <v-title>Application Needs Changes</v-title>
          <v-card-text>
            <v-flex xs12>
              <p>{{ rejectText }}</p>
              <vonex-text
                v-if="!showClose"
                v-model="requiredChanges"
                name="rejectMessage"
                :options="fieldConditions"
                placeholder="Enter required changes - dealer will be notified with details."
              ></vonex-text>
              <!-- <v-textarea
                v-if="!showClose"
                v-model="requiredChanges"
                name="rejectMessage"
                placeholder="Enter required changes - dealer will be notified with details."
              ></v-textarea> -->
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!showClose"
              large
              color="primary"
              @click.native="rejectApplication()"
            >
              Send Back
              <br />
              to Dealer
            </v-btn>
            <v-btn
              v-if="!showClose"
              large
              color="light-grey"
              @click.native="rejected = false"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="showClose"
              large
              color="light-grey"
              @click.native="closeWindow()"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="approved">
        <v-card>
          <v-title>Thank you</v-title>
          <v-card-text>
            <v-flex xs12>
              <p class="headline">
                This finance application will be held until the remainder of
                your Vonex order is completed and signed. It will then be
                attached to the order when it is signed and sent for processing.
              </p>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large color="light-grey" @click.native="closeWindow()">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card v-if="!isDataLoading && hasData && !hasWitness">
        <v-title>Do you have a witness?</v-title>
        <v-card-text class="subheading">{{ witnessDialogText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="primary" @click.native="haveWitness(true)">
            Yes
          </v-btn>
          <v-btn large color="red" dark @click.native="haveWitness(false)">
            No
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-show="hasWitness">
        <v-title>Application Details</v-title>
        <v-card-text>
          <div
            align-center
            justify-center
            style="
              overflow: auto;
              -webkit-overflow-scrolling: touch;
              height: 600px;
              width: 100%;
              margin: auto;
            "
          >
            <div id="viewer"></div>
            <!-- <iframe
              id="viewer"
              style="width:100%;height:600px;text-align:center;"
              allowfullscreen
              ref="report"
              type="image/png"
            ></iframe>-->
          </div>
        </v-card-text>
      </v-card>

      <v-card v-if="hasWitness">
        <v-title>AUTHORISATION</v-title>

        <v-layout row align-center>
          <v-flex sm12 md12 lg12>
            <vonex-checkbox
              v-model="application.financeApplicationDetails.doNotDisclose"
              :input-value="application.financeApplicationDetails.doNotDisclose"
              class="red-darken-3"
              :options="fieldConditions"
              label="By ticking this box I/we do not consent to you using and
          disclosing my/our personal information for the purpose described in
          “Ongoing contact” immediately above."
            ></vonex-checkbox>
            <!-- <v-checkbox
              v-model="application.financeApplicationDetails.doNotDisclose"
              class="red-darken-3"
              label="By ticking this box I/we do not consent to you using and
          disclosing my/our personal information for the purpose described in
          “Ongoing contact” immediately above."
            ></v-checkbox> -->
          </v-flex>
        </v-layout>

        <v-layout row align-center>
          <v-flex sm8 md8 lg8>
            <label class="heading">
              Do you accept the information and terms laid out within this
              information above?
            </label>
          </v-flex>
          <v-btn
            color="success"
            :disabled="agreed | rejected"
            @click="agreed = true"
          >
            I agree
            <v-icon>thumb_up</v-icon>
          </v-btn>
          <v-btn
            color="red"
            dark
            :disabled="agreed | rejected"
            @click="rejected = true"
          >
            Needs Changes
          </v-btn>
        </v-layout>
      </v-card>

      <v-card v-if="hasWitness && agreed" row>
        <v-title>Upload Documents</v-title>
        <v-layout>
          <v-flex sm12 md12 lg12>
            <FileUploader
              :is-on-upload-page="true"
              :order-g-u-i-d="finOrderGUID"
            >
              Upload photo of the front and back of your drivers license
            </FileUploader>
          </v-flex>
        </v-layout>
      </v-card>

      <v-layout v-if="hasWitness && agreed && hasData" justify-start>
        <v-flex sm12 md12 lg12>
          <v-title>Signatures</v-title>
          <v-flex sm12 md12 lg12></v-flex>

          <v-layout>
            <v-flex sm12 md12 lg12>
              <v-card>
                <v-card-title>Authorised Representative Signature</v-card-title>
                <v-img
                  v-if="application.financeApplicationDetails.signature"
                  id="sign_prev"
                  :src="application.financeApplicationDetails.signature"
                ></v-img>
                <v-card-text>
                  <v-layout
                    v-show="!application.financeApplicationDetails.isSigned"
                    row
                    wrap
                    align-center
                  >
                    <VueSignaturePad
                      id="signature"
                      ref="signaturePad"
                      save-type="image/png"
                      :custom-style="customStyle"
                    />
                  </v-layout>
                  <v-flex sm4 md4 lg4>
                    <label class="subheading">
                      <vonex-text
                        v-model="
                          application.financeApplicationDetails.authorisedRep
                        "
                        label="Authorised Representative"
                        name="authorisedRep"
                        :disabled="
                          application.financeApplicationDetails.isSigned
                        "
                        data-vv-as="Authorised Representative"
                        :rule="'required'"
                        :options="fieldConditions"
                      />
                      <!-- <v-text-field
                        label="Authorised Representative"
                        name="authorisedRep"
                        :disabled="application.financeApplicationDetails.isSigned"
                        v-model="application.financeApplicationDetails.authorisedRep"
                        :error-messages="errors.collect('authorisedRep')"
                        data-vv-as="Authorised Representative"
                        v-validate="'required'"
                      /> -->
                    </label>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    :disabled="application.financeApplicationDetails.isSigned"
                    color="primary"
                    @click="undo(true)"
                  >
                    Undo
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex sm12 md12 lg12>
              <v-card>
                <v-card-title>Witness Signature</v-card-title>
                <v-card-media
                  v-if="application.financeApplicationDetails.witnessSignature"
                  id="sign_prev"
                  :src="application.financeApplicationDetails.witnessSignature"
                ></v-card-media>
                <v-card-text>
                  <v-layout
                    v-show="!application.financeApplicationDetails.isSigned"
                    row
                    wrap
                    align-center
                  >
                    <v-flex xs12></v-flex>
                    <VueSignaturePad
                      id="witnessSignature"
                      ref="witnessSignaturePad"
                      save-type="image/png"
                      :custom-style="customStyle"
                    />
                  </v-layout>
                  <v-flex sm4 md4 lg4>
                    <vonex-text
                      v-model="
                        application.financeApplicationDetails.witnessName
                      "
                      label="Name of Witness"
                      name="witnessName"
                      :disabled="application.financeApplicationDetails.isSigned"
                      data-vv-as="Name of the Witness"
                      :rule="'required'"
                      :options="fieldConditions"
                    />
                    <!-- <v-text-field
                      label="Name of Witness"
                      name="witnessName"
                      :disabled="application.financeApplicationDetails.isSigned"
                      v-model="application.financeApplicationDetails.witnessName"
                      :error-messages="errors.collect('witnessName')"
                      data-vv-as="Name of the Witness"
                      v-validate="'required'"
                    /> -->
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    :disabled="application.financeApplicationDetails.isSigned"
                    color="primary"
                    @click="undo(false)"
                  >
                    Undo
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="hasWitness && agreed" justify-start row>
        <v-flex sm12 md12 lg12>
          <v-btn color="primary" @click="approveApplicationAndSend()">
            Save and Send
          </v-btn>
          <v-btn color="primary" @click="undo">Undo</v-btn>
          <v-btn color="primary" @click="clearSignatures()">Clear</v-btn>
        </v-flex>
      </v-layout>
    </v-content>
  </v-content>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);
import { httpError } from '../models/httpError';
const { mapActions: mapFinanceApplicationActions } = createNamespacedHelpers(
  `orders/financeApplication`
);
import FileUploader from './FileUploader';

export default {
  name: 'ViewFinance',
  components: {
    FileUploader,
  },
  data() {
    return {
      application: [],
      isValid: false,
      isDataLoading: false,
      customStyle: {
        'background-color': '#1aa25714',
        'background-image': `url(${require('@/assets/images/SignHereWatermark.png')}`,
        'background-repeat': 'no-repeat',
        'background-size': 'contain',
        height: '320px',
        width: '100%',
        'background-position': 'center',
      },
      hasWitness: null,
      showSignatures: false,
      witnessDialogText:
        'In order to sign this document, you are required to have a witness. Is one present with you?',
      requiredChanges: '',
      rejected: false,
      rejectText:
        'Please note, rejection of application will render this link unusable until dealer makes the amendments and resends the application with the link',
      hasData: true,
      agreed: false,
      approved: false,
      finOrderGUID: null,
      showClose: false,
    };
  },
  mounted() {
    let vm = this;
    vm.isDataLoading = true;

    const dictionary = {
      en: {
        custom: {
          authorisedRep: {
            required: 'Please enter the name of your authorised representative',
          },
          witnessName: {
            required: 'Please enter the name of your witness',
          },
        },
      },
    };

    Validator.localize('en', dictionary);
    // or use the instance method
    this.$validator.localize('en', dictionary);

    vm.getFinanceApplicationFromGUID(this.$route.params.guid)
      .then((res) => {
        vm.application = res;
        vm.getOrderGUID(res.orderID).then(
          (result) => (vm.finOrderGUID = result)
        );
        vm.hasData = true;

        vm.generateApplicationPDF(
          vm.application.financeApplicationDetails,
          false
        )
          .then(() => {
            vm.isDataLoading = false;
            vm.hasWitness = false;
            vm.hasData = true;
          })
          .catch(() => {
            vm.isDataLoading = false;
            vm.hasData = false;
            vm.message = new httpError({
              message: 'There is no data',
              httpStatus: 500,
            });
          });
      })
      .catch((err) => {
        vm.isDataLoading = false;
        vm.hasData = false;
        vm.message = new httpError({
          message: err,
          httpStatus: 500,
        });
      });
  },
  methods: {
    ...mapFinanceApplicationActions([
      'updateFinanceApplication',
      'getFinanceApplication',
      'setMessage',
      'populateApplication',
      'getFinanceApplicationFromGUID',
      'approveApplicationCustomer',
      'rejectApplicationCustomer',
      'getOrderGUID',
    ]),
    haveWitness(witness) {
      let vm = this;
      if (witness) {
        vm.witnessDialogText =
          'Please review the application and sign at the bottom';
        vm.hasWitness = true;
      } else
        vm.witnessDialogText =
          'Please reopen this application when you have a someone present to witness your signature.';
    },
    closeWindow() {
      window.close();
    },
    generateApplicationPDF(application, isPDF) {
      return new Promise((resolve, reject) => {
        let vm = this;
        let payload = { application, isPDF };
        vm.isDataLoading = true;
        let pdf = vm.populateApplication(payload);
        pdf
          .then((res) => {
            vm.isDataLoading = false;
            let viewer = document.getElementById('viewer');
            let parent = viewer.parentElement;
            let newViewer = document.createElement('iframe');
            viewer.remove();
            newViewer.setAttribute('src', URL.createObjectURL(res));
            newViewer.setAttribute('scrolling', 'no');
            newViewer.style = 'width:100%; height:2600px;';
            parent.appendChild(newViewer);
            resolve(res);
          })
          .catch((error) => {
            vm.message = new httpError({
              message: 'Error in generated application:' + error,
              httpStatus: 500,
            });
            reject(error);
          });
      });
    },
    download() {
      let vm = this;
      vm.isDataLoading = true;
      vm.populateApplication(vm.application, true)
        .then((res) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              res,
              `Finance Application - ${vm.application.applicationID}.pdf`
            );
            // for all other web browsers, display the converted PDF as iframe
          } else {
            let url = URL.createObjectURL(res);
            let link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.download = `Finance Application - ${vm.application.financeApplicationID}.pdf`;

            document.body.appendChild(link);
            link.click();
          }
          vm.isDataLoading = false;
        })
        .catch(() => {});
    },
    approveApplicationAndSend() {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          if (!vm.emptyGUID()) {
            //This is where the customer signs the application

            let signatureData = vm.getSignature(vm.$refs.signaturePad);
            let witnessSignatureData = vm.getSignature(
              vm.$refs.witnessSignaturePad
            );
            if (
              signatureData != null &&
              witnessSignatureData != null &&
              (vm.application.financeApplicationDetails.witnessName !==
                'undefined') |
                (vm.application.financeApplicationDetails.witnessName !==
                  null) &&
              (vm.application.financeApplicationDetails.authorisedRep !==
                'undefined') |
                (vm.application.financeApplicationDetails.authorisedRep !==
                  null)
            ) {
              //Activate the dialog
              vm.isPDFAttaching = true;
              vm.isDataLoading = true;
              vm.application.financeApplicationDetails.signature =
                signatureData;
              vm.application.financeApplicationDetails.witnessSignature =
                witnessSignatureData;
              vm.application.financeApplicationDetails.isSigned = true;
              vm.application.financeApplicationDetails.dateofSignature =
                new Date();
              vm.approveApplicationCustomer(vm.application)
                .then(() => {
                  vm.isPDFAttaching = false;
                  vm.isDataLoading = false;
                  vm.application = null;
                  vm.hasWitness = false;
                  vm.hasData = false;
                  vm.approved = true;
                })
                .catch((error) => {
                  vm.isDataLoading = false;
                  vm.isPDFAttaching = false;
                  vm.isPDFAttaching = false;
                  vm.message = new httpError({
                    message: 'Unable to approve:' + error,
                    httpStatus: 500,
                  });
                });
            } else {
              vm.isPDFAttaching = false;
              vm.message = new httpError({
                message:
                  'Please ensure to include an signature, your name, a witness signature and witness name',
                httpStatus: 500,
              });
            }
          }
        } else {
          vm.message = new httpError({
            message:
              'Please ensure to include an signature, your name, a witness signature and witness name',
            httpStatus: 500,
          });
        }
      });
    },
    rejectApplication() {
      let vm = this;

      vm.isDataLoading = true;
      //Activate the dialog
      let changes = vm.requiredChanges;
      let app = vm.application;
      let data = { changes, app };
      vm.rejectApplicationCustomer(data)
        .then(() => {
          vm.isPDFAttaching = false;
          vm.isDataLoading = false;
          vm.application = [];
          vm.hasData = false;
          vm.hasWitness = false;
          vm.rejectText =
            'Your application has been sent to our dealer and being added to your order.';
          vm.showClose = true;

          //vm.rejected = false;
          //window.close();
        })
        .catch((error) => {
          vm.isDataLoading = false;
          vm.isPDFAttaching = false;
          vm.isPDFAttaching = false;
          vm.rejected = false;
          vm.message = new httpError({
            message: 'Unable to reject:' + error,
            httpStatus: 500,
          });
          vm.hasData = false;
        });
    },
    getSignature(signaturePad) {
      const { isEmpty, data } = signaturePad.saveSignature();
      if (!isEmpty && data.length > 6) return data;
      return null;
    },
    openRejectedDialog() {
      let vm = this;
      vm.rejected = true;
    },
    clearSignatures() {
      let vm = this;
      vm.$refs.signaturePad.clearSignature();
      vm.$refs.witnessSignaturePad.clearSignature();
      vm.application.financeApplicationDetails.isSigned = false;
      vm.application.financeApplicationDetails.dateofSignature = null;
    },
    undo(signaturePad) {
      let vm = this;
      if (signaturePad) vm.$refs.signaturePad.undoSignature();
      else vm.$refs.witnessSignaturePad.undoSignature();
      vm.application.financeApplicationDetails.isSigned = false;
      vm.application.financeApplicationDetails.dateofSignature = null;
    },
    emptyGUID() {
      let vm = this;
      if (
        vm.application.finGUID == null ||
        vm.application.finGUID == '00000000-0000-0000-0000-000000000000'
      )
        return true;
      return false;
    },
  },
};
</script>

<style></style>
